import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_label = _resolveComponent("base-label")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_component_tooltip, {
    enabled: $options.hasTooltip,
    text: $props.tooltipText
  }, {
    default: _withCtx(() => [
      _createVNode(_component_base_label, _mergeProps({theme: $props.theme, shape: $props.shape}, {
        class: [{ 'gfu-label--achievement': !$options.onlyIcon }]
      }), {
        default: _withCtx(() => [
          ($options.hasIcon)
            ? (_openBlock(), _createBlock(_component_base_icon, {
                key: 0,
                name: $props.icon,
                "icon-namespace": $props.iconNamespace,
                size: $props.iconSize
              }, null, 8 /* PROPS */, ["name", "icon-namespace", "size"]))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString($props.name), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */, ["class"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["enabled", "text"]))
}